angular.module('wbDashboard').controller('PlanningControllerAurea', ['$scope', '$uibModal', 'PlanningService', 'Message', function ($scope, $uibModal, PlanningService, Message) {
    $scope.pageData = {
        sending: false,
        dismissReason: null
    };
    $scope.forms = {};

    $scope.recommendations = false;
    $scope.recommendationInfo = {};
    $scope.stagePercent = 0;
    $scope.previousRecommendations = null;

    $scope.$watch(function() { return PlanningService.getRecommendations(); }, function(recommendations) {
        //when updated after survey
        if (recommendations) {
            $scope.recommendations = recommendations;
            $scope.previousRecommendations = PlanningService.get('previousRecommendations');
        }
        if (["base.planning", "base.overview"].indexOf($scope.$state.current.name) > -1) {
            PlanningService.stageModal($scope);
        }
    }, true);
    $scope.$watch(function() { return PlanningService.getRecommendationInfo(); }, function(recommendationInfo) {
        if (recommendationInfo) {
            $scope.recommendationInfo = recommendationInfo;

            $scope.stagePercent = ($scope.recommendationInfo.stage_percentage_complete / 4) + (($scope.recommendationInfo.current_stage_number-1)* 25);
        }
    });

    $scope.snoozeFor = function(recommendation, days) {

        var tillDate = moment().add(days, 'days').format('YYYY-MM-DD');
        recommendation.snoozed = true;
        PlanningService.snoozeRecommendation(recommendation.recommendation_slug, tillDate, days).then(function() {
            recommendation.snoozed = true;

            //PlanningService.removeRecommendationItem(recommendation.recommendation_slug);
            return PlanningService.retrieveRecommendations(true);
        }).catch(function() {
            recommendation.snoozed = false;
            Message.set({
                type: "warning",
                text: "There was an issue snoozing your recommendation."
            });
        });
    };

    $scope.dismissModal = function(recommendation) {

        var modalScope = $scope.$new();
        modalScope.r = recommendation;

        var modalInstance = $uibModal.open({
            templateUrl: 'modal-planning-dismiss-reason.tpl.html',
            scope:modalScope,
            size: 'md',
            windowClass:'confirm-modal'
        });

        modalInstance.result.then(function () {
            recommendation.dismissed = true;
            PlanningService.dismissRecommendation(recommendation.recommendation_slug, $scope.pageData.dismissReason).then(function() {
                recommendation.dismissed = true;

                // PlanningService.removeRecommendationItem(recommendation.recommendation_slug);
                Message.set({
                    type: "success",
                    text: "Success. Thanks for the feedback!"
                });
            }).catch(function() {
                recommendation.dismissed = false;
                Message.set({
                    type: "warning",
                    text: "There was an issue dismissing your recommendation."
                });

                // PlanningService.removeRecommendationItem(recommendation.recommendation_slug);

            }).finally(function() {
                return PlanningService.retrieveRecommendations(true);
            });
        }).catch(angular.noop);
    };

    $scope.getNextSurveyRecommendation = PlanningService.getNextSurveyRecommendation;

    $scope.gotoNextSurvey = function() {
        $scope.pageData.sending = true;
        PlanningService.gotoNextSurveyRecommendation($scope).finally(function() {
            $scope.pageData.sending = false;
        });
    };

    //prevent leaving page if still a case where they should be here
    var transitionDeregisterHook = $scope.$transitions.onSuccess({to: 'base.planning'}, function(trans) {
        PlanningService.stageModal($scope);
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });
}]);
